import { GENERAL_LOADER, NOTIFICATION_CLEAR, NOTIFICATION_TRIGGER, SET_CHAT_CHANNEL_ID, SET_NOTIFICATION_COUNT } from "../constants";

const initialState = {
    isNotification: false,
    notificationCount: 0,
    data: {},
    chatChannelId: null,
    generalLoading: false,
}

export default function GeneralReducer(state = initialState, action) {
    switch (action.type) {
        case NOTIFICATION_TRIGGER:
            state = {
                ...state,
                isNotification: true,
                data: action.payload
            }
            break;
        case NOTIFICATION_CLEAR:
            state = {
                ...state,
                isNotification: false,
                data: {}
            }
            break;
        case SET_NOTIFICATION_COUNT:
            state = {
                ...state,
                notificationCount: action.payload,
            }
            break;
        case SET_CHAT_CHANNEL_ID:
            state = {
                ...state,
                chatChannelId: action.payload
            }
            break;
        case GENERAL_LOADER:
            state = {
                ...state,
                generalLoading: action.payload
            }
            break;
        default:
            break;
    }
    return state;
} 